import { I18n } from '@calendly/i18n'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { MembershipsPickerModal } from 'features/memberships_picker'

import {
  assignPopupGroupIdsSelector,
  assignPopupInvitationIdsSelector,
  assignPopupMembershipIdsSelector,
  assignPopupScopeSelector,
  assignPopupUserGroupIdSelector,
  eventTypeSelector,
  isAssignPopupOpenSelector,
  isAssignPopupSubmittingSelector,
  membershipsWithSlugConflictSelector
} from '../selectors'
import {
  assignManagedEventTypeMemberships,
  closeAssignPopup,
  closeSlugConflictsPopup
} from '../slice'
import { getMembershipsPickerConfiguration } from './configuration'
import { SlugConflictPopup } from './slug_conflict_popup'

export const AddMembersPopup = () => {
  const dispatch = useDispatch()
  const { id: managedEventTypeId, slug } = useSelector(eventTypeSelector)
  const isOpen = useSelector(isAssignPopupOpenSelector)
  const isSubmitting = useSelector(isAssignPopupSubmittingSelector)
  const userGroupId = useSelector(assignPopupUserGroupIdSelector)
  const hasSlugConflict = useSelector(membershipsWithSlugConflictSelector).length > 0
  const membershipIds = useSelector(assignPopupMembershipIdsSelector)
  const invitationIds = useSelector(assignPopupInvitationIdsSelector)
  const groupIds = useSelector(assignPopupGroupIdsSelector)
  const scope = useSelector(assignPopupScopeSelector)
  const [membershipsPickerValue, setMembershipsPickerValue] = useState({})

  const config = getMembershipsPickerConfiguration(scope, { slug })

  const getUnavailabilityReason = (_, entity) => entity.managed_event_type_ids.includes(parseInt(managedEventTypeId, 10))
    && I18n.t('publisher.organization.managed_event_types.assign.add_members.already_part')

  const handleSubmit = ({ organizationMembershipIds, organizationInvitationIds, userGroupIds }) => {
    if (organizationMembershipIds.length || organizationInvitationIds.length || userGroupIds.length) {
      dispatch(assignManagedEventTypeMemberships({
        managedEventTypeId,
        membershipIds: organizationMembershipIds,
        invitationIds: organizationInvitationIds,
        groupIds: userGroupIds,
        checkSlugConflicts: true,
      }))
    } else {
      dispatch(closeAssignPopup())
    }
  }

  const handleClose = () => {
    dispatch(closeAssignPopup())
  }

  const handleSlugConflictsConfirm = () => {
    dispatch(assignManagedEventTypeMemberships({
      managedEventTypeId,
      membershipIds,
      invitationIds,
      groupIds,
      checkSlugConflicts: false,
    }))
  }

  const handleSlugConflictsCancel = () => {
    setMembershipsPickerValue({
      organizationMembershipIds: membershipIds,
      organizationInvitationIds: invitationIds,
      userGroupIds: groupIds
    })
    dispatch(closeSlugConflictsPopup())
  }

  useEffect(() => {
    setMembershipsPickerValue({})
  }, [isOpen, setMembershipsPickerValue])

  return (
    <>
      <MembershipsPickerModal
        isOpen={isOpen && !hasSlugConflict}
        title={config.title}
        description={config.description}
        inputPlaceholder={config.placeholder}
        submitButtonText={I18n.t('publisher.organization.managed_event_types.assign.assign_button')}
        notFoundPlaceholderTitle={config.notFoundPlaceholderTitle}
        notFoundPlaceholderText={config.notFoundPlaceholderText}
        getUnavailabilityReason={getUnavailabilityReason}
        isSubmitting={isSubmitting}
        initialValue={membershipsPickerValue}
        entities={config.entities}
        selectedSuggestionsComponent={config.selectedSuggestionsComponent}
        onSubmit={handleSubmit}
        onClose={handleClose}
        userGroupId={userGroupId}
        userGroupIds={[userGroupId]}
        includeOnlyGroupMembers={!!userGroupId}
      />
      <SlugConflictPopup
        isOpen={hasSlugConflict}
        title={config.slugConflictsPopupTitle}
        submitButtonText={config.slugConflictsPopupSubmitButtonText}
        cancelButtonText={config.slugConflictsPopupCancelButtonText}
        content={config.slugConflictsPopupContent}
        onSubmit={handleSlugConflictsConfirm}
        onClose={handleSlugConflictsCancel}
      />
    </>
  )
}
